export default __webpack_public_path__ + "media/assets/img/icon_img_small-c5c19a59eddec9518848aada23e64a47.png";